<article class="service-card wide3"
         [class.mobile]="deviceService.isMobile()"
         itemscope itemtype="https://schema.org/Article">

  <ng-container *ngTemplateOutlet="meta"></ng-container>

  <div *ngIf="isBrowser" class="card-cover" (click)="onOpenCardInModal()"></div>

  <div class="type" [ngClass]="eUserServiceType[type]">{{ typeLabel(type) | translate }}</div>

  <div class="tools-panel">
    <on-ui-card-menu>
      <a class="menu-item warn" *ngIf="service.purl" [href]="service.purl">[⚠️] Panel</a>
      <div class="menu-item" *ngIf="debug$ | async" (click)="printDebugInfo()">DEBUG</div>
      <div class="menu-item" (click)="onOpenCardInModal()">
        {{ 'user-service-form-3.actions.previews' | translate }}
      </div>
    </on-ui-card-menu>
  </div>

  <div class="content">
    <div class="cover-wrap">
      <on-ui-cover [cover]="cover"></on-ui-cover>
    </div>

    <a [routerLink]="userServiceRoute" [attr.title]="fullTitle" class="info-block">
      <ng-template [ngIf]="deviceService.isMobile()">
        <div class="category">{{ category }}</div>
        <span class="subject">{{ subjectTitle }}</span>
      </ng-template>
      <div class="title">{{ title }}</div>
      <ng-template [ngIf]="!deviceService.isMobile()">
        <ng-container *ngTemplateOutlet="secondInfo"></ng-container>
      </ng-template>
    </a>
  </div>

  <ng-template [ngIf]="deviceService.isMobile()">
    <ng-container *ngTemplateOutlet="secondInfo"></ng-container>
  </ng-template>

  <div class="actions-block">
    <div class="price-block">
      <div class="old-price">
        <ng-template [ngIf]="discount">
            <span class="price-without-discount">
              {{ getFormattedAmountWithoutDiscount() | async }}
            </span>
          <div class="discount">{{ discount }}% {{ 'library.user-service-card.discount' | translate }}</div>
        </ng-template>
      </div>
      <div class="current-price">
        <span class="price">{{ getFormattedAmount() | async }}</span>
        <span class="period">{{ labelPeriod | translate }}</span>
      </div>
    </div>

    <ng-template [ngIf]="service?.can?.signup"
                 [ngIfThen]="availableActionsRef"
                 [ngIfElse]="notAvailableActionsRef">
    </ng-template>
  </div>
</article>

<ng-template #availableActionsRef>
  <on-ui-button *ngIf="service?.can?.signup"
                class="secondary"
                [label]="isRegularClass() ? 'library.user-service-card.subscribe' : 'library.user-service-card.sign-up-for-a-lesson'"
                (click)="goSignup($event)">
  </on-ui-button>
</ng-template>

<ng-template #notAvailableActionsRef>
  <on-ui-button class="status"
                label="teacher-card.actions.no-available-hours">
  </on-ui-button>
</ng-template>

<ng-template #secondInfo>
  <div class="second-info">
    <div class="row">
      <span class="text">
        {{ (isSingle ? 'library.user-service-card.one-on-one' : 'library.user-service-card.group') | translate }}
      </span>
      <div class="separator"></div>
      <ng-template [ngIf]="isRegularClass" [ngIfElse]="otherServices">
        <span class="text">
          {{ 'teacher-card.stats.classes' | translate}} {{ 'event-calendar.ongoing' | translate }}
        </span>
        <div class="separator"></div>
      </ng-template>
      <ng-template #otherServices>
        <ng-template [ngIf]="meetings_limit">
          <span class="text">{{ 'teacher-card.stats.classes' | translate}} {{ meetings_limit }}</span>
          <div class="separator"></div>
        </ng-template>
      </ng-template>
      <span class="text">{{ 'library.user-service-card.entry-level' | translate }}</span>
      <div class="separator"></div>
      <span class="text">{{ 'user-service-form-3.fields.label9' | translate }} {{ age_from }}-{{ age_to }}</span>
    </div>
    <div class="row">
      <ng-template [ngIf]="weekdaysToString()">
        <span class="text">{{ weekdaysToString() }}</span>
        <div class="separator"></div>
      </ng-template>
      <span class="text">{{ duration }} {{ 'library.user-service-card.min' | translate }}</span>
      <ng-template [ngIf]="false">
        <div class="separator"></div>
        <span class="text">10:00 - 11:00</span>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #meta>
  <meta itemprop="url" content="{{ userServiceRoute }}"/>
  <meta itemprop="name" content="{{ fullTitle }}"/>
  <meta itemprop="datePublished" content="{{ contentDate?.toISOString() }}"/>
  <meta itemprop="image" content="{{ metaImageUrl || coverImageUrl }}"/>
  <meta *ngIf="description" itemprop="description" content="{{ description | striptags }}"/>
  <meta itemprop="headline" content=""/>
  <meta itemprop="inLanguage" content="{{ service.language?.code }}"/>
</ng-template>
